import React from 'react';
import {useDispatch, useSelector} from "react-redux";
import {
    bbDangerousStringToDate, bbDoesUserHaveAccessToBreachRiskLevelForEntity,
    bbFindEntityWithinPortfolioOrSelf,
    bbFormattedDateString
} from "../../../util/bbHelpers";
import {BRCustomizedTooltip as Tooltip} from "../accents/BRCustomizedTooltip";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";
import {renderCellExpand} from "../tables/DataGridRenderCellExpand";
import BBDataTable from "../tables/BBDataTable";
import NewBRProvidingElementDialog from "./NewBRProvidingElementDialog";
import NewBRIdentityProvidedForm from "./NewBRIdentityProvidedForm";
import BBIconCheckboxCheckedYes from "../../../assets/bbCustomIcons/BBIconCheckboxCheckedYes";
import BBIconCheckCircleYes from "../../../assets/bbCustomIcons/BBIconCheckCircleYes";
import BBIconRoundedDashNull from "../../../assets/bbCustomIcons/BBIconRoundedDashNull";
import {Button} from "@material-ui/core";
import BBIconArchive from "../../../assets/bbCustomIcons/BBIconArchive";
import BBIconAdd from "../../../assets/bbCustomIcons/BBIconAdd";
import {updateBRIdentityProvided} from "../../../actions";

const BRIdentitiesProvidingTable = ({
                                        portfolioView=false,
                                    }) =>{

    const {customers, customerInView} = useSelector(({customer}) => customer);
    const {entityInView, portfolios, loadingPortfolios, loadingPortfoliosError, loadingCycles, loadingCyclesError, loadingCycleDetails, loadingCycleDetailsError} = useSelector(({breachrisk}) => breachrisk);
    const {authUser} = useSelector(({auth}) => auth);

    const dispatch = useDispatch();

    const customerIdToUse = customers ? customerInView ? customerInView : null : null;
    const customer = customers ? customers[customerIdToUse] : null;

    const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerIdToUse);
    const isTrustedAgentForThisEntity = bbDoesUserHaveAccessToBreachRiskLevelForEntity(authUser, "infoLevel3", entityInView);
    const isAdministratorForThisEntity = bbDoesUserHaveAccessToBreachRiskLevelForEntity(authUser, "infoLevel4", entityInView);


    const entityHasSocialOn = myEntity && myEntity.settings && myEntity.settings.social_testing_authorized;

    const lastCycle = myEntity ? myEntity.last_cycle : null

    const social = myEntity
        && myEntity.cycles
        && myEntity.cycles[lastCycle.cycle]
        && myEntity.cycles[lastCycle.cycle].social

    const totals= social && social.totals;

    const identitiesArray = myEntity
        && myEntity.cycles
        && myEntity.cycles[lastCycle.cycle]
        && myEntity.cycles[lastCycle.cycle].social
        && myEntity.cycles[lastCycle.cycle].social.identities
        && Object.keys(myEntity.cycles[lastCycle.cycle].social.identities)

    const identities = identitiesArray && Array.isArray(identitiesArray) && identitiesArray.map((identity)=>{

        return{
            id: identity,
            ...myEntity.cycles[lastCycle.cycle].social.identities[identity]
        }
    });

    // const providedIdentities = identities && Array.isArray(identities) && identities.filter((id)=> id.provided);

    const providedIdentities = myEntity && myEntity.identities_provided  ? Object.values(myEntity.identities_provided) : null;

    const tableData = providedIdentities && Array.isArray(providedIdentities)
        ? providedIdentities.map((identity)=>{
            return{
                lastModifiedDate: identity.last_modified && bbDangerousStringToDate(identity.last_modified),
                providedDate: identity.provided_datetime && bbDangerousStringToDate(identity.provided_datetime),
                ...identity
            }
        })
        : [];

    const totalNumProvidedIds = providedIdentities && Object.keys(providedIdentities).length;

    const hasSocialData = totals && ((totals.number_identities + totals.number_social_tests + totals.number_social_tests_action_taken +
        totals.number_social_tests_opened + totals.number_social_tests_successful) > 0);


    // console.log(tableData);

    const title = <div className={"tourStepBRProvidedIdentities"}>
        Identities Added By You<Tooltip title={"Identities you've added to increase the fidelity of your score."}>
        <InfoSharpIcon style={{fontSize: "smaller"}} className={``}/>
    </Tooltip>
    </div>;

    const description = <p className={"ml-2 pl-1"}>
        <em>
            If your company has access to social engineering and has authorized social tests, you can add any identities not yet discovered for future testing.
        </em>
    </p>

    const handleClick = (value)=>{
        dispatch(updateBRIdentityProvided({
            entityId: entityInView,
            customerId: customerIdToUse,
            identityId: value.identityId,
            newIsActiveStatus: value.newIsActiveStatus,

        }))
    }

    const columns = [
        { field: 'id', headerName: 'ID', hide: true, flex : 1, sortable: true, type: 'string', renderCell: (params) => {
                return params.value}},
        { field: 'email', headerName: 'Email', hide: false, flex : 1, sortable: true, type: 'string',cellClassName: "addedIdentitiesNameCol",
            renderHeader: (params) =>
                <span id={"addedIdentitiesHeader"}>Domain</span>,
            renderCell: (params) =>
                renderCellExpand(params, (
                    <Tooltip title={``}>
                    <span>
                        {params.value ? params.value : "---"}
                    </span>
                    </Tooltip>))},
        { field: 'first', headerName: 'First', hide: false, flex : 1, sortable: true, type: 'string', renderCell: (params) =>
                renderCellExpand(params, (<Tooltip title={``}>
                    <span>
                        {params.value ? params.value : "--"}
                    </span>
                </Tooltip>))},
        { field: 'last', headerName: 'Last', hide: false, flex : 1, sortable: true, type: 'string', renderCell: (params) =>
                renderCellExpand(params, (
                    <Tooltip title={``}>
                    <span>
                        {params.value ? params.value : "---"}
                    </span>
                    </Tooltip>))},
        // { field: 'position', headerName: 'Position', hide: false, flex : 1, sortable: true, type: 'string', renderCell: (params) =>
        //         renderCellExpand(params, (
        //             <Tooltip title={``}>
        //             <span>
        //                 {params.value ? params.value : "---"}
        //             </span>
        //             </Tooltip>))},
        { field: 'providedDate', headerName: 'Date Added', hide: false, sortable: true, type: 'dateTime', flex : 0.5, renderCell: (params) =>
                renderCellExpand(params, (<Tooltip title={``}>
                          <span>
                              {params.value
                                  ? <span>
                                      {bbFormattedDateString(params.value, "short")}
                                  </span>
                                  : "N/A"}

                          </span>
                    </Tooltip>

                ))},
        { field: 'lastModifiedDate', headerName: 'Last Modified', hide: false, sortable: true, type: 'dateTime', flex : 0.5, renderCell: (params) =>
                renderCellExpand(params, (<Tooltip title={``}>
                          <span>
                              {params.value
                                  ? <span>
                                      {bbFormattedDateString(params.value, "short")}
                                  </span>
                                  : "N/A"}

                          </span>
                    </Tooltip>

                ))},
        { field: 'is_active', headerName: 'Active',
            renderHeader: (params) => <div style={{lineHeight: "normal"}}><Tooltip title={"Active"}>
                <span><BBIconCheckboxCheckedYes/></span>
            </Tooltip></div>, hide: false, sortable: true, type: 'string', width: 61, renderCell: (params) =>
                renderCellExpand(params, (<>
                        {params.value
                            ? <Tooltip title={`This element appeared to be active during our last observation.`}>
                                  <span>
                                    <BBIconCheckCircleYes className={'text-bb-risk-low'}/>
                                  </span>
                            </Tooltip>
                            : <Tooltip title={`This element did not appear to be active during our last observation.`}>
                                  <span>
                                    <BBIconRoundedDashNull/>
                                  </span>
                            </Tooltip>
                        }
                    </>

                ))},
        { field: 'actions', headerName: 'Actions', hide: false, width : 90, sortable: false, type: 'string',
            renderCell: (params) => {

                return <>
                    {params.row.is_active
                        ? <div style={{marginRight:2}}>
                            <Tooltip title={"Archive & remove element if you believe it is not a part of your IT infrastructure. You can add it back later."}>
                          <span>
                              <Button
                                  variant="outlined"
                                  color="default"
                                  onClick={() => handleClick({identityId: params.row.id, newIsActiveStatus: false})}
                              >
                              <BBIconArchive />
                          </Button>
                          </span>

                            </Tooltip>
                        </div>
                        : <div style={{marginRight:2}}>
                            <Tooltip title={"Reactivate this identity if you believe it is a part of your IT infrastructure."}>
                          <span>
                              <Button
                                  variant="outlined"
                                  color="default"
                                  className={"text-electric-blue"}
                                  onClick={() => handleClick({identityId: params.row.id, newIsActiveStatus: true})}
                              >
                              <BBIconAdd />
                          </Button>
                          </span>

                            </Tooltip>
                        </div>
                    }


                </>
            }

        },
    ]

    return(
        <div>
            {myEntity
            && myEntity.cycles
            && myEntity.cycles[lastCycle.cycle]
            // && myEntity.cycles[lastCycle.cycle].social
                // && social.identities_provided
                // && providedIdentities
                ?
                <BBDataTable
                    columns={columns}
                    rows={tableData}
                    title={title}
                    loading = {false}
                    progressValue={100}
                    enableExport
                    authUser = {authUser}
                    entityId = {entityInView}
                    customer={customer}
                    description={description }
                    topRightElement={
                        <NewBRProvidingElementDialog
                            disabled={portfolioView ? !isAdministratorForThisEntity : false}
                            formComponent={<NewBRIdentityProvidedForm entityId={entityInView}/>}
                            buttonLabel={"Identity"}
                        />
                    }
                    lite={!isTrustedAgentForThisEntity}
                    portfolioStarter={!isTrustedAgentForThisEntity}
                />
                :
                <BBDataTable
                    columns={columns}
                    rows={[]}
                    title={title}
                    description={description }
                    loading = {true}
                    progressValue={0}
                    bufferValue={15}
                    lite={!isTrustedAgentForThisEntity}
                    portfolioStarter={!isTrustedAgentForThisEntity}
                />
            }
        </div>
    )
}

export default BRIdentitiesProvidingTable;